import { ProvenanceBadge } from "./Primitives.web";
import type { DashaPeriod } from "./types";

export function DashaTimeline({
  periods,
  title = "Dasha timeline",
  titleId = "dasha-timeline-title",
}: {
  periods: readonly DashaPeriod[];
  title?: string;
  titleId?: string;
}) {
  return (
    <section className="jyotish-dasha" aria-labelledby={titleId}>
      <header>
        <h3 id={titleId}>{title}</h3>
        <ProvenanceBadge kind="engine" label="Computed period sequence" />
      </header>
      <ol>
        {periods.map((period) => (
          <li key={period.id} className={period.active ? "is-active" : undefined}>
            <span className="jyotish-dasha__rail" aria-hidden />
            <div>
              <div className="jyotish-dasha__heading">
                <strong>{period.label}</strong>
                {period.active ? <span>Current</span> : null}
              </div>
              <p>
                {period.start} – {period.end}
              </p>
              {period.description ? <p>{period.description}</p> : null}
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}

export default DashaTimeline;
